import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-100 text-center py-6 mt-10">
      <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-700">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
        <Link to="/refund-policy">Refund Policy</Link>
        <Link to="/shipping-policy">Shipping Policy</Link>
        <Link to="/contact-us">Contact Us</Link>
      </div>
      <p className="mt-4 text-xs text-gray-500">© 2025 MyStore. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
